// extracted by mini-css-extract-plugin
export default {"root":"ORZPR","opening":"O8Dg_","open":"pXZ1b","closing":"tWlfQ","footer-placeholder":"suELw","footer":"L0EDe"};